<template>
  <nav
    aria-label="Breadcrumb"
    class="w-full max-w-7xl mx-auto px-3 xl:px-0 mt-4 text-sm text-gray-400"
  >
    <ol class="flex flex-wrap items-center gap-1">
      <li
        v-for="crumb in trail"
        :key="`crumb-${crumb.name}`"
        class="flex gap-1"
      >
        <NuxtLink v-if="crumb.path" :to="crumb.path" class="hover:underline">
          {{ crumb.name }}
        </NuxtLink>
        <span v-else aria-current="page" class="text-gray-200">
          {{ crumb.name }}
        </span>
        <span v-if="crumb.path" aria-hidden="true">›</span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
  // A trail of `{ name, path }` crumbs; the last one, the current page, has no
  // path. buildBreadcrumbSchema takes the same trail.
  defineProps({
    trail: {
      type: Array,
      required: true,
    },
  })
</script>
